// src/redux/settingsPages/emailPreferences/emailPreferencesAPI.js
import apiClient from '../../authentication/utils/core/axios';

const EmailPreferencesAPI = {
  async getPreferences() {
    const res = await apiClient.get('/email/preferences');
    return res.data;
  },

  async updatePreferences(patch) {
    const res = await apiClient.put('/email/preferences', patch);
    return res.data;
  },
};

export default EmailPreferencesAPI;
